import * as preact from "preact";

import models from "models/models";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as signupModal from "signupModal";
import * as urlUtils from "urlUtils";
import ToggleSwitch from "views/ToggleSwitch";

type Props = {
  appRouter: any;
};

type State = {
  billingPeriod: "month" | "year";
};

class CheckoutPageView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      billingPeriod: "year",
    };
  }

  async componentDidMount() {
    console.log("CheckoutPageView mounted");
    if (await readlangClient.isLocalMode()) {
      signupModal.show({
        models: models,
        headingHtml: "<h2>Sign in to Readlang</h2>",
        cancelCallback: () => {
          this.props.appRouter.navigate("/account", { trigger: true });
        },
      });
    }
  }

  render() {
    console.log("rendering CheckoutPageView");
    $("head title").text("Checkout");

    const emailVerificationStatus = urlUtils.getUrlVar(
      "emailVerificationStatus"
    );
    const justVerifiedEmail = urlUtils.getUrlVar("justVerifiedEmail");
    const userID = models.user.id;

    $('.plan input[name="custom"]').val(userID);

    const openCheckout = function (
      billingPeriod: "month" | "year",
      plan: "premium" | "premiumPlus"
    ) {
      if (!userID) {
        alert("No userID");
        return;
      }

      window.location.href = `/api/createCheckoutSession/${billingPeriod}?plan=${plan}`;
    };

    const premiumPlan = (
      <div class="plan2">
        <div class="billingPeriod">
          Premium <small>(most popular)</small>
        </div>
        <div class="price">
          ${this.state.billingPeriod === "year" ? 4 : 6}
          <small> / month</small>
        </div>

        {this.state.billingPeriod === "year" ? (
          <div class="yearlyCostBreakdown">
            Yearly cost
            <div class="yearlyCost">US$48</div>
          </div>
        ) : null}

        <button
          class="payNowButton"
          onClick={() => {
            openCheckout(this.state.billingPeriod, "premium");
          }}
        >
          Pay now
        </button>
      </div>
    );

    const premiumPlusPlan = (
      <div class="plan2">
        {/* <div class="saveNotice">Save $24</div> */}
        <div class="billingPeriod">
          Premium Plus <small>(better AI + more audio)</small>
        </div>
        <div class="price">
          ${this.state.billingPeriod === "year" ? 10 : 15}
          <small> / month</small>
        </div>

        {this.state.billingPeriod === "year" ? (
          <div class="yearlyCostBreakdown">
            Yearly cost
            <div class="yearlyCost">US$120</div>
          </div>
        ) : null}

        <button
          class="payNowButton secondary"
          onClick={() => {
            openCheckout(this.state.billingPeriod, "premiumPlus");
          }}
        >
          Pay now
        </button>
      </div>
    );

    const writtenConversationMessage = (
      <>
        <strong>* Written Conversation</strong> is available in all languages{" "}
        <strong>except for</strong>{" "}
        {languageMap.list
          .filter(
            (language) => !languageMap.languageSupportsChat(language.code)
          )
          .map((language) => language.english)
          .join(", ")}
        .
      </>
    );
    const speakingModeMessage = (
      <>
        <strong>** Speaking Mode</strong> is available in Arabic, Catalan,
        Chinese, Danish, Dutch, English, Finnish, French, German, Greek, Hindi,
        Indonesian, Italian, Japanese, Korean, Norwegian, Polish, Portuguese,
        Russian, Slovak, Spanish, Swedish, Ukrainian.
      </>
    );
    const cancelMessage = (
      <>
        <strong>Readlang Premium</strong> is a subscription service. You can{" "}
        <strong>cancel at any time</strong>, and you won't be charged again.
      </>
    );
    const languagesMessage = (
      <>
        <strong> One Premium subscription</strong> will work across all
        supported languages, so you can{" "}
        <strong>study multiple languages at the same time</strong>.
      </>
    );
    const switchPlansMessage = (
      <>
        After subscribing you can{" "}
        <strong>switch between Premium and Premium Plus plans</strong>. Any
        remaining days on your current subscription will be automatically
        adjusted and applied to the new plan using a prorated calculation. e.g.
        if you have 8 days left on your Premium Plus plan and decide to
        downgrade, this will turn into 20 days on the Premium plan (8 x 2.5).
      </>
    );

    return (
      <>
        <div class="checkoutPage2Contents">
          <div id="header">
            <div class="bookColumn">
              <div class="topBar">
                <a href="/" class="logoLink">
                  <img class="rabbitLogo" src="/content/rabbitLogo.svg" />
                  Readlang
                </a>
              </div>
              <h1>Become bilingual faster!</h1>
              <div class="toggle-container">
                <ToggleSwitch
                  stateOne="monthly billing"
                  stateTwo="yearly billing"
                  onToggle={(selected) => {
                    console.log("selected: ", selected);
                    this.setState({
                      billingPeriod:
                        selected === "monthly billing" ? "month" : "year",
                    });
                  }}
                />
                <div class="discount-pill">-33%</div>
              </div>
            </div>
          </div>

          <div class="planContainer2">
            {emailVerificationStatus === "sent" ? (
              <div
                id="verificationNoticeSent"
                class="verificationNotice callout"
              >
                IMPORTANT: We've just sent an email to{" "}
                <span class="email"></span> with a link to verify your email
                address. Please click the link in the email to continue.
              </div>
            ) : emailVerificationStatus === "sentPreviously" ? (
              <div
                id="verificationNoticeSentPreviously"
                class="verificationNotice callout"
              >
                IMPORTANT: We previously sent an email to{" "}
                <span class="email"></span> with a link to verify your email
                address. Please click that link in the email to continue.
              </div>
            ) : justVerifiedEmail === "true" ? (
              <div id="justVerifiedEmail" class="callout">
                Thanks for verifying your email address!
                <br />
                Choose one of the options below to continue.
              </div>
            ) : null}
            {/* {deviceDetect.isSmall() ? (
              <>
                {premiumPlusPlan}
                {premiumPlan}
              </>
            ) : ( */}
            <>
              {premiumPlan}
              {premiumPlusPlan}
            </>
            {/* )} */}

            <h2 class="noMobile">What's included in each plan?</h2>
            <h2 class="mobileOnly">What's included in Premium?</h2>

            <div class="mobileFeatureList2">
              <table class="mobileFeatureListTable">
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Unlimited Phrase Translations</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="subtle">(instead of 10 / day)</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Phrases of up to 12 words long</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="subtle">(instead of 6)</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Unlimited Context Explanations</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Context-Aware Translations</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="subtle">(instead of 10 / day)</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>5 hours of audio storage</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Generate stories with the Story Bot</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Practice or export flashcards from specific books</td>
                </tr>

                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    Auto Highlighting, Shelves, Speaking Mode<sup>*</sup>
                  </td>
                </tr>
              </table>
            </div>

            <h2 class="mobileOnly">What's included in Premium Plus?</h2>

            <div class="mobileFeatureList2">
              <table class="mobileFeatureListTable">
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>Everything from Premium</td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    Better AI model powering context-aware translations,
                    explanations and summaries
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>200 hours of audio storage</td>
                </tr>
              </table>
            </div>

            <div class="mobileMessages">
              <p>{speakingModeMessage}</p>
              <p class="larger">{cancelMessage}</p>
              <p class="larger">{languagesMessage}</p>
              <p class="larger">{switchPlansMessage}</p>
            </div>

            <div class="featureTable noMobile">
              <table>
                <tr>
                  <th>
                    <h3>Features</h3>
                  </th>
                  <th>
                    <h3>Free</h3>
                  </th>
                  <th>
                    <h3>Premium</h3>
                  </th>
                  <th>
                    <h3>Premium Plus</h3>
                  </th>
                </tr>
                <tr>
                  <td colspan={4}>
                    <div class="dividerLine"></div>
                  </td>
                </tr>
                <tr>
                  <td>Single word translations</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Text uploads</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Flashcard practices</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Maximum words translated per phrase</td>
                  <td>6 words</td>
                  <td>12 words</td>
                  <td>12 words</td>
                </tr>
                <tr>
                  <td>Phrase translations</td>
                  <td>10 / day</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Context explanations</td>
                  <td>10 / day</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Word highlighting</td>
                  <td>200 words in total</td>
                  <td>Unlimited</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Context-aware translations</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                </tr>
                <tr>
                  <td>Audio upload and transcription</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    5 hours
                    <br />
                    storage
                  </td>
                  <td>
                    100 hours
                    <br />
                    storage
                  </td>
                </tr>
                <tr>
                  <td>Written conversations *</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>2 / day</td>
                  <td>Unlimited</td>
                </tr>
                <tr>
                  <td>Generate stories with the Story Bot</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                </tr>
                <tr>
                  <td>Practice words from specific texts</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                </tr>
                <tr>
                  <td>Speaking mode **</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                </tr>
                <tr>
                  <td>Shelves</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                  <td>
                    <div class="checkout-check-circle"></div>
                  </td>
                </tr>
                <tr>
                  <td>Streak repair</td>
                  <td>
                    <div class="checkout-x-circle"></div>
                  </td>
                  <td>2 / month</td>
                  <td>2 / month</td>
                </tr>
                <tr>
                  <td>
                    AI model
                    <br />
                    <small>
                      (powers context explanations, context-aware translations,
                      review summaries)
                    </small>
                  </td>
                  <td>
                    GPT-4o mini
                    <br />
                    <small>(limited&nbsp;usage)</small>
                  </td>
                  <td>
                    GPT-4o mini
                    <br />
                    &nbsp;
                  </td>
                  <td>
                    GPT-4o
                    <br />
                    <small>(state of the art)</small>
                  </td>
                </tr>
                <tr>
                  <td colspan={4}>
                    <div class="dividerLine"></div>
                  </td>
                </tr>
              </table>
              <p class="tableFooterInfo">
                <p>{writtenConversationMessage}</p>
                <p>{speakingModeMessage}</p>
                <div class="tableFooterCallout">
                  <p>{cancelMessage}</p>
                  <p>{languagesMessage}</p>
                  <p>{switchPlansMessage}</p>
                </div>
              </p>
            </div>
          </div>
        </div>
        <div id="footer">
          <div class="bookColumn">
            <div class="row">
              <div id="socialLinks">
                <p>Connect with us</p>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/readlang" class="logo">
                      <i class="icon-facebook-sign"></i>
                    </a>
                    <a href="https://twitter.com/Readlang" class="logo">
                      𝕏
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col2_3">
                <ul>
                  <li>
                    <a href="https://www.youtube.com/watch?v=wF31VqZMqE8&index=2&list=PLIGa-eWCssj_dcE9GXkpLSFB9t8qZyZn2">
                      Tutorial Videos
                    </a>
                  </li>
                  <li>
                    <a href="https://forum.readlang.com/">
                      Help &amp; Feedback
                    </a>
                  </li>
                  <li>
                    <a href="http://blog.readlang.com">Readlang Blog</a>
                  </li>
                  <li>
                    <a href="/webReader">Web Reader Extension & Bookmarklet</a>
                  </li>
                  <li>
                    <a href="https://forum.readlang.com/t/install-readlang-on-your-iphone-ipad-or-android-home-screen/45">
                      Readlang for iOS and Android
                    </a>
                  </li>
                  <li>
                    <a data-bypass="true" href="/landing-page">
                      Landing Page
                    </a>
                  </li>
                  <li>
                    <a href="/privacyPolicy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/termsOfService">Terms of Service</a>
                  </li>
                  <li>
                    <a href="/account">Pricing</a>
                  </li>
                  <li>
                    <a href="http://blog.readlang.com/about">About & Contact</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CheckoutPageView;
